import * as ActionTypes from './ActionTypes';
import InitialState from './InitialState';
import { assign } from '../../shared/Assign';
import IFeatureState from '../../store/IFeatureState';

export default function planEditorsReducer(
    state: any = InitialState.planEditors,
    action: { type: string; result: any }
): any {
    let newState: IFeatureState;

    switch (action.type) {
        case ActionTypes.LIST_PLAN_EDITORS_SUCCESS:
            newState = assign({}, state);
            newState.list = action.result;
            return newState;

        case ActionTypes.NEW_PLAN_EDITOR_SUCCESS:
            newState = assign({}, state);
            newState.new = {
                planFirms: [...action.result.planFirms],
                availableRoles: [...action.result.availableRoles],
                availableLanguages: [...action.result.availableLanguages]
            };
            return newState;

        case ActionTypes.CREATE_PLAN_EDITOR_SUCCESS:
            newState = assign({}, state);
            newState.list = [...state.list, assign({}, action.result)];
            return newState;

        case ActionTypes.EDIT_PLAN_EDITOR_SUCCESS:
            newState = assign({}, state);
            newState.edit = assign({}, action.result);
            return newState;

        case ActionTypes.UPDATE_PLAN_EDITOR_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;

        case ActionTypes.DELETE_PLAN_EDITOR_SUCCESS:
            newState = assign({}, state);
            newState.list = [...state.list.filter((x: any) => x.id !== action.result)];
            return newState;

        default:
            return state;
    }
}
